import { NbToastrService } from '@nebular/theme';
import { AuthService } from '../auth-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, HostListener, OnInit } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import * as Sentry from "@sentry/angular";

@Component({
  selector: 'ngx-app-auth-login',
  templateUrl: './auth-login.component.html',
  styleUrls: ['./auth-login.component.scss'],
})
export class AuthLoginComponent implements OnInit {
  errors: string[] = [];
  environmentName: string;
  culture: string;
  user: any;
  onderhoudsmodusActief: boolean = false;
  onderhoudsmodusTekst: string = '';
  submitted = false;
  isLoadingOnderhoudsmodus = true;

  mfaCode: string = '';
  requiresMfa: boolean = false;
  mfaToken: string = '';
  boxes = [0, 1, 2, 3, 4, 5];
  recoveryBoxes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]; // 10 karakters voor herstelcode (XXXXX-XXXXX)
  isVerifying = false;
  isUsingRecoveryCode: boolean = false;
  recoveryCode: string = '';
  returnUrl: any;


  constructor(public jwtHelper: JwtHelperService, private httpClient: HttpClient, private router: Router, private authService: AuthService, private route: ActivatedRoute,
    private toastrService: NbToastrService, private _translateService: TranslateService, private _authService: AuthService) {
    this.environmentName = environment.environmentName;
    if (environment.production) {
      this.user = {
        username: '',
        password: '',
      };
    } else {
      this.user = {
        username: 'AurioSoftware',
        password: '',
      };
    }

    _authService.getOnderhoudsmodusActief().subscribe({
      next: (value) => {
        this.onderhoudsmodusActief = value['OnderhoudsmodusActief'];
        this.onderhoudsmodusTekst = value['OnderhoudsmodusTekst'];
        this.isLoadingOnderhoudsmodus = false;
      },
      error: (err) => {
        this.onderhoudsmodusActief = true;
        this.onderhoudsmodusTekst = this._translateService.instant('LOGIN.MELDING.ONDERHOUD');
        this.isLoadingOnderhoudsmodus = false;
        Sentry.captureMessage("Fout bij het ophalen van de onderhoudsmodus status, onderhoudsmodus automatisch geactiveerd", "fatal");
      }
    }
    );
  }

  ngOnInit() {
    this.errors = [];
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];

    this.culture = this._authService.getCulterByLanguage();

    if (this.router.url === '/auth/logout') {
      this.authService.logout();
    }

    if (this.jwtHelper.getTokenExpirationDate() !== null && !this.jwtHelper.isTokenExpired()) {
      this.router.navigateByUrl(this.authService.getStartPageUrl());
      //this.router.navigateByUrl('/pages/seveso/dashboard');
    } else if (this.jwtHelper.getTokenExpirationDate() !== null) {
      this.toastrService.warning(this._translateService.instant('LOGIN.MELDING.SESSIE_VERLOPEN.TEKST'), this._translateService.instant('LOGIN.MELDING.SESSIE_VERLOPEN.TITEL'));
      this.authService.logout();
    }
  }

  login(): void {
    this.submitted = true;
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };

    const body = new URLSearchParams();
    body.append('username', this.user.username);
    body.append('password', this.user.password);
    body.append('grant_type', 'password');

    this.httpClient.post(environment.ApiTokenEndpoint + '?culture=' + this.culture, body, options)
      .subscribe({
        next: (response: any) => {
          this.submitted = false;
          if (response.setupMfa) {
            //response.mfaSessionId
            sessionStorage.setItem('mfaSessionId', response.mfaSessionId);
            this.router.navigate(['auth/mfa-setup']);
          } else if (response.requiresMfa) {
            this.errors = [];
            this.requiresMfa = true;
            this.mfaToken = response.mfaToken;
            setTimeout(() => {
              const el = document.getElementById("mfa-0") as HTMLInputElement;
              el?.focus();
            }, 0);
          } else {
            localStorage.setItem('id_token', response['access_token']);
            localStorage.setItem('refresh_token', response['refresh_token']);
            localStorage.setItem('ActiveCustomerId', response['activeCustomerId']);
            this.authService.logLogon().subscribe();
            this.authService.startRefreshTokenTimer();

            if (!!this.returnUrl) {
              this.router.navigate([this.returnUrl]);
            } else {
              this.router.navigateByUrl(this.authService.getStartPageUrl());
            }
          }
        },
        error: (error) => {
          const message = error.error.error_description;
          this.submitted = false;

          if (!!message) {
            this.errors[0] = message;
          } else {
            this.errors[0] = this._translateService.instant('LOGIN.MELDING.TECHNISCHE_FOUT');
          }
          this.authService.logFailedLogon();
          Sentry.setUser(null);
        }
      });
  }


  verifyMfa() {
    if (this.isVerifying) return;
    this.isVerifying = true;

    const body = new URLSearchParams();
    body.set('grant_type', 'mfa');
    if (this.isUsingRecoveryCode) {
      body.set('recoveryCode', this.recoveryCode);
    } else {
      body.set('code', this.mfaCode);
    }
    body.set('mfaToken', this.mfaToken);

    this.httpClient.post<TokenResponse>(`${environment.ApiTokenEndpoint}`, body.toString(), {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    }).subscribe({
      next: (response: any) => {
        localStorage.setItem('id_token', response['access_token']);
        this.errors = [];

        localStorage.setItem('refresh_token', response['refresh_token']);

        if (!!this.returnUrl) {
          this.router.navigate([this.returnUrl]);
        } else {
          this.router.navigate(['pages', 'dashboard']);
        }
      },
      error: (err: any) => {
        const message = err.error.error_description;

        if (!!message) {
          this.errors[0] = message;
        } else {
          this.errors[0] = this._translateService.instant('LOGIN.MELDING.TECHNISCHE_FOUT');
        }
        this.isVerifying = false;
        this.mfaCode = '';
        this.recoveryCode = '';

        if (this.isUsingRecoveryCode) {
          this.recoveryBoxes.forEach((i) => {
            const box = document.getElementById(`recovery-${i}`) as HTMLInputElement;
            if (box) box.value = '';
          });
          setTimeout(() => {
            const el = document.getElementById("recovery-0") as HTMLInputElement;
            el?.focus();
          }, 0);
        } else {
          this.boxes.forEach((i) => {
            const box = document.getElementById(`mfa-${i}`) as HTMLInputElement;
            if (box) box.value = '';
          });
          setTimeout(() => {
            const el = document.getElementById("mfa-0") as HTMLInputElement;
            el?.focus();
          }, 0);
        }
        Sentry.setUser(null);
      }
    });
  }

  onInput(event: any, index: number) {
    const input = event.target;
    const value = input.value.replace(/[^0-9]/g, "");
    input.value = value;

    if (value && index < 5) {
      // volgende vakje focussen
      const next = document.getElementById(`mfa-${index + 1}`) as HTMLInputElement;
      next?.focus();
    }

    this.updateCode();
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    if (event.key === "Backspace" && !input.value && index > 0) {
      const prev = document.getElementById(`mfa-${index - 1}`) as HTMLInputElement;
      prev?.focus();
    }
  }

  onPaste(event: ClipboardEvent) {
    const paste = event.clipboardData?.getData('text') ?? "";
    const digits = paste.replace(/\D/g, "").slice(0, 6);

    digits.split("").forEach((d, i) => {
      const box = document.getElementById(`mfa-${i}`) as HTMLInputElement;
      if (box) box.value = d;
    });

    this.updateCode();

    event.preventDefault();
  }

  updateCode() {
    const values = this.boxes
      .map(i => (document.getElementById(`mfa-${i}`) as HTMLInputElement)?.value ?? "");

    this.mfaCode = values.join("");

    // Als alle 6 cijfers zijn ingevuld → automatisch valideren
    if (this.mfaCode.length === 6 && /^[0-9]{6}$/.test(this.mfaCode)) {
      this.verifyMfa();
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.key == 'd') {
      this.onderhoudsmodusActief = false;
      event.preventDefault();
    }
  }

  restoreMfa(event): void {
    event.preventDefault();
    this.isUsingRecoveryCode = true;
    this.errors = [];
    this.recoveryCode = '';
    setTimeout(() => {
      const el = document.getElementById("recovery-0") as HTMLInputElement;
      el?.focus();
    }, 0);
  }

  backToMfa(event): void {
    event.preventDefault();
    this.isUsingRecoveryCode = false;
    this.errors = [];
    this.mfaCode = '';
    setTimeout(() => {
      const el = document.getElementById("mfa-0") as HTMLInputElement;
      el?.focus();
    }, 0);
  }

  onRecoveryInput(event: any, index: number) {
    const input = event.target;
    let value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    input.value = value;

    if (value && index < 9) {
      const next = document.getElementById(`recovery-${index + 1}`) as HTMLInputElement;
      next?.focus();
    }

    this.updateRecoveryCode();
  }

  onRecoveryKeyDown(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;

    if (event.key === "Backspace" && !input.value && index > 0) {
      const prev = document.getElementById(`recovery-${index - 1}`) as HTMLInputElement;
      prev?.focus();
    }
  }

  onRecoveryPaste(event: ClipboardEvent) {
    const paste = event.clipboardData?.getData('text') ?? "";
    // Verwijder streepje en houd alleen alfanumerieke karakters
    const chars = paste.replace(/[^A-Z0-9]/gi, "").toUpperCase().slice(0, 10);

    chars.split("").forEach((c, i) => {
      const box = document.getElementById(`recovery-${i}`) as HTMLInputElement;
      if (box) box.value = c;
    });

    this.updateRecoveryCode();
    event.preventDefault();
  }

  updateRecoveryCode() {
    const values = this.recoveryBoxes
      .map(i => (document.getElementById(`recovery-${i}`) as HTMLInputElement)?.value ?? "");

    // Eerste 5 karakters
    const part1 = values.slice(0, 5).join("");
    // Tweede 5 karakters
    const part2 = values.slice(5, 10).join("");

    // Formaat: XXXXX-XXXXX
    this.recoveryCode = part1 + (part2 ? '-' + part2 : '');

    // Als alle 10 karakters zijn ingevuld → automatisch valideren
    if (part1.length === 5 && part2.length === 5) {
      this.verifyMfa();
    }
  }

}

interface TokenResponse {
  access_token?: string;
  refresh_token?: string;
  token_type?: string;
  expires_in?: number;
  requiresMfa?: boolean;
  mfaToken?: string;
  message?: string;
  mfaRequired?: boolean;
  mfaSessionId?: string;
}

